import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { Breakpoints } from '@angular/cdk/layout';
import { BreakpointsService }  from "../../../common/services/breakpoints.service";
import { INavItem } from '../../interfaces/nav-item';
import { menu } from '../../models/menu';
import { environment } from '../../../../environments/environment';
import { IBrandProfile } from '../../../common/interfaces/brand-profile';
import { SharedService }  from "../../../common/services/shared.service";
import { TokenStorageService }  from "../../../common/services/token-storage.service";
import { BrandProfileService } from '../../../common/services/brand-profile.service';
import { UserAuthService }  from "../../../common/services/user-auth.service";
import { SidenavService }  from "../../../common/services/sidenav.service";
// import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})

export class SideNavComponent implements OnInit {

  appVerion: string = "v.2024-05.1";
  environmentBanner: string = environment.environmentBanner;
  isProdEnvironment: boolean = environment.production;
  appRegion: string = !this.isProdEnvironment ? "@ " + environment.production : '';  

  // @ViewChild('MatSidenav') public sidenav!: MatSidenav;
  @ViewChild(MatSidenav) sidenav!: MatSidenav;

  brandProfile!: IBrandProfile;  
  brandStyleTheme: any = {};
  brandName: string = '';

  brandLogoImage! : any;
  isBrandLogoImageShown: boolean = false;  

  public opened = true;
  public menu: INavItem[] = menu;
  public isUserAuthenticated: boolean = true;

  public constructor(
    private router: Router,
    private breakpointsService: BreakpointsService,
    private sharedService: SharedService,
    private userAuthService: UserAuthService,  
    private sidenavService: SidenavService,
    private brandProfileService: BrandProfileService,
    private tokenStorageService: TokenStorageService,
    // private observer: BreakpointObserver     
    ) {}    

    // ngAfterViewInit() {
    //   this.observer.observe(["(max-width: 800px)"]).subscribe((res: any) => {
    //     if (res.matches) {
    //       this.sidenav.mode = "over";
    //       this.sidenav.close();
    //     } else {
    //       this.sidenav.mode = "side";
    //       this.sidenav.open();
    //     }
    //   });
    // }


  ngOnInit(): void {
    console.log('side-nav: ngOnInit()', this.sidenav);
    this.sidenavService.setSidenav(this.sidenav);

    this.breakpointsService.breakpoint$.subscribe(() =>
      {
        let currentBreakpoint: string = this.breakpointsService.breakpointChanged();
        if (currentBreakpoint === Breakpoints.Small || currentBreakpoint === Breakpoints.XSmall) {
          this.opened = false;
        } else {
          this.opened = true;
        }
      }
    );

    // let brandCode: string = this.sharedService.getBrandCode();
    let brandProfile: IBrandProfile = this.sharedService.getBrandProfile();
    if (brandProfile) {
      this.brandName = brandProfile.brandName;
      // Display the brand logo image, if possible    
      this.brandLogoImage = null;
      this.isBrandLogoImageShown = false;
      if (brandProfile.logoImage) {
        this.brandLogoImage = 'data:' + brandProfile.logoImage.imageType + ';base64,' + brandProfile.logoImage.imageContent;
        this.isBrandLogoImageShown = true;
      }
    }
    // this.brandProfileService.resetCurrentBrand(brandCode);

    // Get the current brand profile
    if (this.sharedService.getBrandProfile()) {
      this.brandProfile = this.sharedService.getBrandProfile();
      this.brandStyleTheme = this.sharedService.getBrandStyleScheme(this.brandProfile);
    }    
  }


  signout() {
    // clean up current brand and its profile
    this.userAuthService.logout();
    // let emptyBrandProfile: IBrandProfile = {
    //   brandCode: '',
    //   brandName: ''
    // };
    // this.sharedService.setEnvRegion('');
    // this.sharedService.setBaseUrl('');
    // this.sharedService.setBrandCode('');
    // this.sharedService.setBrandProfile(emptyBrandProfile);
    // this.sharedService.setAccountNum('');
    // // make the actual logout
    // this.tokenStorageService.setAuthToken('')
    // this.tokenStorageService.setUserPrivileges(['']);
    this.router.navigate(['/login']);
  }  

}
